var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcWifi = function SvgIcWifi(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.005,
    height: 22.005,
    viewBox: "0 0 22.005 22.005",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_rss_feed_24px",
    transform: "translate(-5.968 10.691) rotate(-45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 2.18,
    cy: 2.18,
    r: 2.18,
    transform: "translate(4 15.64)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M4,4.44V7.27A12.731,12.731,0,0,1,16.73,20h2.83A15.565,15.565,0,0,0,4,4.44ZM4,10.1v2.83A7.076,7.076,0,0,1,11.07,20H13.9A9.9,9.9,0,0,0,4,10.1Z",
    fill: "#999"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcWifi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wifi.3a166bbb5e6b9914b2bdaf8dc6ad4cb2.svg";